import styled from "styled-components";

const Avatar = styled.img`
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border-radius: 100%;
`
export default Avatar